
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/mab-100",
      function () {
        return require("private-next-pages/[lang]/mab-100.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lang]/mab-100"])
      });
    }
  